<div class="mb-4 w-full flex items-center justify-between text-slate-200 test-xs md:text-xs lg:text-xs xl:text-xs">
  <!-- <check-btn [text]="'Nhớ mật khẩu của bạn' | titlecase"></check-btn> -->
  <atom-text-link [class]="'text-blue-600'" [text]="'Quên mật khẩu?'" [linkData]="link" (click)="closeAllDidalog()"></atom-text-link>
</div>